<template>
  <div>
    <success-fade-alert ref="alert" :msg="alert.success" />
    <fade-alert-danger ref="danger" :msg="alert.error" />

    <h1>
      {{ $t("sector.edit") }}
    </h1>
    <b-row class="mb-3 ml-0">
      <router-link to="./../all">
        <b-button size="sm">{{ $t("geral.backtolist") }}</b-button>
      </router-link>
    </b-row>

    <b-row>
      <b-col sm="12" md="6" lg="6">
        <sector-crud :model.sync="model" :modelstate="modelstate" />
      </b-col>
    </b-row>

    <b-button class="mt-4" @click="save" type="submit" :disabled="submitted">
      {{ $t("geral.save") }}
    </b-button>
  </div>
</template>
<script>
export default {
  name: "SectorEdit",
  props: {
    id: Number
  },
  components: {
    SectorCrud: () => import("@/components_rms/System/Sector/Crud.vue"),
    FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue")
  },
  created() {
    this.loadData();
  },
  data() {
    return {
      alert: {
        error: "",
        success: "Setor editado com sucesso"
      },
      model: {},
      submitted: false,
      modelstate: {}
    };
  },
  methods: {
    loadData() {
      this.$apiScheduler.get("/sector/getById/" + this.id).then(response => {
        this.model = response.data;
      });
    },
    save() {
      this.submitted = true;
      this.$apiScheduler
        .post("/sector/edit/", this.model)
        .then(response => {
          //   this.cleanModel();
          this.submitted = false;
          this.$refs.alert.show();
        })
        .catch(error => {
          this.submitted = false;
          console.log(error);
          console.log(error.response);
          console.log(error.errorCode);

          switch (error.response.status) {
            case 401:
              this.$store.dispatch("logout").then(() => {
                this.$router.push("/login");
              });
              break;
            case 400:
              if (error.response.data.errorCode) {
                this.modelstate = error.response.data.errors;
                this.alert.error = `${error.response.data.errorCode} - ${error.response.data.errorMessage}`;
                this.$refs.danger.show();
              } else {
                this.modelstate = error.response.data.errors;
                this.alert.error = error.message;
                this.$refs.danger.show();
              }
              break;
            default:
              if (error.response.data.errorCode) {
                this.modelstate = error.response.data.errors;
                this.alert.error = `${error.response.data.errorCode} - ${error.response.data.errorMessage}`;
                this.$refs.danger.show();
              } else {
                this.modelstate = {};
                this.alert.error = error.message;
                this.$refs.danger.show();
              }
              break;
          }
        });
    }
  }
};
</script>
